/**
 * Keyboard scroll-assist — keeps the focused field in sight when the soft
 * keyboard comes up. The native hosts shrink the web view above the keyboard
 * (WebViewHostViewController on iOS, WebViewInsets on Android), which reaches
 * the page as a resize that makes the viewport shorter; that resize, not a
 * timer, is when the focused field is scrolled back into view. Covers screens
 * and teleported overlays alike.
 *
 * Inside a container marked `data-keyboard-reveal="center"` the field is
 * centered rather than brought just above the keyboard, so what is around it
 * stays in sight (the tenant login and registration forms).
 */
const FOCUSABLE = 'input, textarea, select, [contenteditable="true"]'

let installed = false

export function installKeyboardAssist(): void {
  if (installed) return
  installed = true

  let height = window.innerHeight
  window.addEventListener('resize', () => {
    const shrank = window.innerHeight < height
    height = window.innerHeight
    if (shrank) revealFocusedField()
  })
}

function revealFocusedField(): void {
  const field = document.activeElement
  if (!(field instanceof HTMLElement) || !field.matches(FOCUSABLE)) return

  const block = field.closest('[data-keyboard-reveal="center"]') ? 'center' : 'nearest'
  field.scrollIntoView({ block, behavior: 'smooth' })
}
